// Run an async task per item with a cap on how many run at once.
// Uses Promise.allSettled semantics (a rejected task does not abort the rest).
// Results are returned in the SAME order as the input items.
const runWithConcurrency = async (items, taskFn, concurrency = 4) => {
  const results = new Array(items.length);
  let nextIndex = 0;

  const worker = async () => {
    while (true) {
      const current = nextIndex++;
      if (current >= items.length) {
        return;
      }
      try {
        const value = await taskFn(items[current], current);
        results[current] = { status: "fulfilled", value };
      } catch (reason) {
        results[current] = { status: "rejected", reason };
      }
    }
  };

  const workerCount = Math.min(concurrency, items.length);
  const workers = [];
  for (let i = 0; i < workerCount; i++) {
    workers.push(worker());
  }
  await Promise.all(workers);

  return results;
};

export default runWithConcurrency;
